import React from 'react';
import { Container, Header, Segment, List, Divider, Message } from 'semantic-ui-react';

const CGU = () => {
    return (
        <Container text>
            <Container text>
                <Segment raised>
                    <Header as="h1" textAlign="center">
                        Conditions Générales d'Utilisation (CGU)
                    </Header>

                    <Divider />

                    <Header as="h2">1. Objet</Header>
                    <p>
                        Les présentes Conditions Générales d'Utilisation (ci-après "CGU") ont pour objet de définir les conditions d'accès et d'utilisation du site <strong>Fablia</strong> (ci-après "le Site"), édité par la société <strong>Fablia</strong> (ci-après "l'Editeur"). 
                        En accédant au Site et en y maintenant votre connexion, vous acceptez les présentes CGU sans réserve.
                    </p>

                    <Header as="h2">2. Description des services</Header>
                    <p>
                        Le Site propose des services de lecture, de création, d'édition et d'hébergement d'histoires interactives contenant du contenu généré par Intelligence Artificielle. Sont définies comme des histoires interactives des contenus prenant la forme de d'échanges de messages entre un ou plusieurs personnages incarnés par un ou plusieurs humains et un ou plusieurs personnages dont les messages sont générés au moyen d'un système d'Intelligence Artificielle. 
                    </p>
                    <p>
                        Ces services peuvent être gratuits ou payants et peuvent nécessiter une inscription. 
                        Ces services peuvent être modifiés ou suspendus à tout moment par l'Editeur, sans justification nécessaire.
                    </p>

                    <Header as="h2">3. Accès au site</Header>
                    <p>
                        L'Editeur met tout en œuvre pour assurer un accès au Site 24h/24 et 7j/7. Toutefois, il ne garantit pas une accessibilité ininterrompue et se réserve le droit d'interrompre l'accès pour maintenance ou en cas de force majeure.
                    </p>

                    <Header as="h2">4. Obligations des Utilisateurs</Header>
                    <p>
                        L'Utilisateur s'engage à respecter les règles suivantes :
                    </p>
                    <List bulleted>
                        <List.Item>Ne pas utiliser le Site à des fins illégales ou frauduleuses.</List.Item>
                        <List.Item>Ne pas diffuser de contenus illicites, diffamatoires ou portant atteinte aux droits de tiers.</List.Item>
                        <List.Item>Maintenir la confidentialité de ses identifiants (le cas échéant).</List.Item>
                        <List.Item>
                            Ne pas tenter d'endommager, de surcharger, de perturber ou de nuire de quelque manière que ce soit au bon fonctionnement du Site.
                        </List.Item>
                    </List>
                    <p>
                        L'Editeur se réserve le droit de suspendre ou de supprimer tout compte Utilisateur en cas de non-respect de ces obligations.
                    </p>

                    <Header as="h2">5. Propriété intellectuelle</Header>
                    <p>
                        Tous les contenus du Site (textes, images, logos, etc.) sont la propriété exclusive de l'Editeur ou de ses partenaires et sont protégés par le droit de la propriété intellectuelle. Toute reproduction ou utilisation non autorisée est interdite.
                    </p>
                    <p>
                        Concernant les contenus hébergés ou générés par les Utilisateurs, ces derniers accordent à l'Editeur une licence non exclusive et gratuite d'utilisation et de diffusion, lui permettant de représenter, reproduire, modifier, adapter, distribuer et diffuser le contenu n’importe où et sur n’importe quel support pour la durée de la propriété intellectuelle. Cela peut se faire directement ou par l’intermédiaire d’un tiers autorisé. Cela concerne notamment le droit d’utilisation du contenu sur le web et sur les réseaux de téléphonie mobile.
                    </p>
                    <p>
                        La suppression ou la modification par le Site du contenu de l’Utilisateur peut s’effectuer à tout moment, pour n’importe quelle raison et sans préavis.
                    </p>

                    <Header as="h2">6. Limitation de responsabilité</Header>
                    <p>
                        L'Editeur ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du Site, notamment causés par des contenus extérieurs accessibles via des liens hypertextes présents sur le Site ou par des contenus hébergés sur le Site par un Utilisateur autre que l'Editeur.
                        Toutes procédures engagées en justice à l’encontre du Site par un tiers lésé par un contenu hébergé sur le Site par un Utilisateur autre que l'Editeur devront être prises en charge par l’Utilisateur.
                        De plus, l'Editeur ne garantit pas l'exactitude ou la fiabilité des contenus affichés, notamment ceux générés par une intelligence artificielle.
                    </p>

                    <Header as="h2">7. Protection des données personnelles</Header>
                    <p>
                        Le Site respecte la réglementation en vigueur en matière de protection des données personnelles, notamment le RGPD.
                        Les utilisateurs disposent des droits suivants :
                        <List bulleted>
                            <List.Item>Droit d'accès, de rectification et de suppression des données personnelles.</List.Item>
                            <List.Item>Droit à la portabilité des données.</List.Item>
                            <List.Item>Droit d'opposition et de limitation du traitement.</List.Item>
                        </List>
                        Pour exercer ces droits, l'utilisateur peut contacter : <a href="mailto:contact@fablia.fr">contact@fablia.fr</a>.
                    </p>
                    <p>
                        Pour plus d'informations sur la gestion des données personnelles par le Site, consultez notre{' '}
                        <a href="/PrivacyPolicy">Politique de confidentialité</a>.
                    </p>

                    <Header as="h2">8. Cookies</Header>
                    <p>
                        Lors des visites sur le Site, l’installation automatique d’un cookie sur le logiciel de navigation de l’Utilisateur peut survenir.
                        Les cookies correspondent à de petits fichiers déposés temporairement sur le disque dur de l’ordinateur de l’Utilisateur. Ces cookies sont nécessaires pour assurer l’accessibilité et la navigation sur le site.
                        L’information présente dans les cookies est utilisée pour améliorer les performances de navigation sur le site Fablia.
                        En naviguant sur le site, l’Utilisateur accepte les cookies. Leur désactivation peut s’effectuer via les paramètres du logiciel de navigation.
                    </p>

                    <Header as="h2">9. Droit applicable et juridiction compétente</Header>
                    <p>
                    Les présentes CGU sont soumises au droit français. L’absence de résolution à l’amiable des cas de litige entre les parties implique le recours aux tribunaux français compétents pour régler le contentieux.
                    </p>

                    <Header as="h2">10. Acceptation des CGU</Header>
                    <p>
                        L'utilisation du Site implique l'acceptation pleine et entière des présentes CGU. Celles-ci peuvent être modifiées à tout moment par l'Editeur. Les utilisateurs seront informés des modifications par un avis publié sur le Site.
                    </p>
                </Segment>
            </Container>
            <Container text>
                <Segment raised>
                    <Header as="h1" textAlign="center">
                        Terms and Conditions of Use (TCU)
                    </Header>

                    <Divider />

                    <Header as="h2">1. Purpose</Header>
                    <p>
                        These Terms and Conditions of Use (hereinafter "TCU") define the conditions for accessing and using the <strong>Fablia</strong> website (hereinafter "the Website"), published by <strong>Fablia</strong> (hereinafter "the Publisher").
                    </p>

                    <Header as="h2">2. Description of Services</Header>
                    <p>
                        The Website offers services for reading, creating, editing, and hosting interactive stories containing content generated by Artificial Intelligence. Interactive stories are defined as content presented in the form of message exchanges between one or more characters played by one or more humans and one or more characters whose messages are generated using an Artificial Intelligence system.
                    </p>
                    <p>
                        These services may be free or paid and may require registration.
                        These services may be modified or suspended at any time by the Publisher, without prior justification.
                    </p>

                    <Header as="h2">3. Site Access</Header>
                    <p>
                        The Publisher strives to ensure access to the Website 24/7. However, uninterrupted accessibility is not guaranteed, and the Publisher reserves the right to interrupt access for maintenance or in case of force majeure.
                    </p>

                    <Header as="h2">4. User Obligations</Header>
                    <p>Users agree to comply with the following rules:</p>
                    <List bulleted>
                        <List.Item>Not to use the Website for illegal or fraudulent purposes.</List.Item>
                        <List.Item>Not to distribute unlawful, defamatory, or rights-infringing content.</List.Item>
                        <List.Item>To maintain the confidentiality of their login credentials (if applicable).</List.Item>
                        <List.Item>Not to attempt to damage, overload, disrupt, or harm the proper functioning of the Website.</List.Item>
                    </List>
                    <p>The Publisher reserves the right to suspend or delete any user account in case of non-compliance with these obligations.</p>

                    <Header as="h2">5. Intellectual Property</Header>
                    <p>
                        All content on the Website (texts, images, logos, etc.) is the exclusive property of the Publisher or its partners and is protected by intellectual property laws. Any unauthorized reproduction or use is prohibited.
                    </p>
                    <p>
                        Regarding content hosted or generated by Users, Users grant the Publisher a non-exclusive, free license to use and distribute the content. This license allows the Publisher to represent, reproduce, modify, adapt, distribute, and broadcast the content anywhere and on any medium for the duration of intellectual property rights. This may be done directly or through an authorized third party. This includes the right to use the content on the web and mobile networks.
                    </p>
                    <p>
                        The Publisher may delete or modify User content at any time, for any reason, and without prior notice.
                    </p>

                    <Header as="h2">6. Limitation of Liability</Header>
                    <p>
                        The Publisher shall not be held responsible for direct or indirect damages resulting from the use of the Website, including those caused by external content accessible via hyperlinks on the Website or by content hosted on the Website by a user other than the Publisher.
                        Any legal proceedings initiated against the Website by a third party harmed by content hosted on the Website by a User other than the Publisher shall be handled by the User.
                        Furthermore, the Publisher does not guarantee the accuracy or reliability of the displayed content, especially that generated by artificial intelligence.
                    </p>

                    <Header as="h2">7. Personal Data Protection</Header>
                    <p>
                        The Website complies with applicable regulations regarding personal data protection, particularly the GDPR.
                        Users have the following rights:
                        <List bulleted>
                            <List.Item>Right of access, rectification, and deletion of personal data.</List.Item>
                            <List.Item>Right to data portability.</List.Item>
                            <List.Item>Right to object to and limit processing.</List.Item>
                        </List>
                        To exercise these rights, users can contact: <a href="mailto:contact@fablia.fr">contact@fablia.fr</a>.
                    </p>
                    <p>
                        More information about personal data gestion by the Site in our{' '}
                        <a href="/PrivacyPolicy">Privacy Policy</a>.
                    </p>

                    <Header as="h2">8. Cookies</Header>
                    <p>
                        During visits to the Website, a cookie may be automatically installed on the User's browser.
                        Cookies are small files temporarily stored on the User's computer hard drive. These cookies are necessary to ensure accessibility and navigation on the Website.
                        The information contained in cookies is used to improve navigation performance on Fablia.
                        By browsing the Website, the User accepts cookies. Disabling them can be done through the browser settings.
                    </p>

                    <Header as="h2">9. Applicable Law and Jurisdiction</Header>
                    <p>
                        These ToU are governed by French law. If disputes cannot be resolved amicably, the competent French courts shall have exclusive jurisdiction to settle the matter.
                    </p>

                    <Header as="h2">10. Acceptance of the TCU</Header>
                    <p>
                        Using the Website implies full and complete acceptance of these TCU. These ToU may be modified at any time by the Publisher. Users will be informed of any changes through a notice published on the Website.
                    </p>
                </Segment>
            </Container>
        </Container>
    );
};

export default CGU;
